import type { ReactElement } from 'react';

import { Navigate, useParams } from 'react-router-dom';

import { ContactDetailPage as ContactDetailFeaturePage } from '../features/contacts/pages/ContactDetailPage.js';

export default function ContactDetailPage(): ReactElement {
  const { contactId } = useParams<{ contactId: string }>();

  if (!contactId) {
    return <Navigate to="/contacts" replace />;
  }

  return <ContactDetailFeaturePage contactId={contactId} />;
}
